import { createSlice } from "@reduxjs/toolkit";
import { KeycloakUserInfo } from "./dto";
import { PromiseStatuses } from "../types";

interface KeycloakState {
  userRoles: string[];
  keycloakInitStatus: PromiseStatuses;
  socket?: WebSocket;
  keycloakUserInfo?: KeycloakUserInfo;
}

const initialState: KeycloakState = {
  userRoles: [],
  keycloakInitStatus: "idle",
};

const keycloakSlice = createSlice({
  name: "keycloak/slice",
  initialState,
  reducers: {
    setRoles: (state, action) => {
      state.userRoles = action.payload;
    },
    setKeycloakInitStatus: (state, action) => {
      state.keycloakInitStatus = action.payload;
    },
    setSocket: (state, action) => {
      state.socket = action.payload;
    },
    setKeycloakUserInfo: (state, action) => {
      state.keycloakUserInfo = action.payload;
    },
  },
});

export const {
  setRoles,
  setKeycloakInitStatus,
  setSocket,
  setKeycloakUserInfo,
} = keycloakSlice.actions;

export default keycloakSlice.reducer;
